"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const ui_1 = require("@phishtool/ui");
const styled_1 = require("./styled");
const products_1 = require("@phishtool/products");
const _service_1 = require("~service");
const modal_1 = require("@phishtool/modal");
const modalId = 'contact';
const Contact = ({ quote }) => {
    const { openModal } = (0, modal_1.useModal)();
    const onClick = (e) => {
        e.preventDefault();
        openModal(modalId);
    };
    return ((0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [(0, jsx_runtime_1.jsxs)(styled_1.StyledQuoteButton, { href: "#", onClick: onClick, children: [(0, jsx_runtime_1.jsx)("span", { children: "Contact sales team" }), (0, jsx_runtime_1.jsx)(ui_1.Icon, { name: "headphones", size: { width: 29, height: 36 }, alignment: "vertical" })] }), (0, jsx_runtime_1.jsx)(ui_1.Modal, { id: modalId, heading: "Contact us", headingSize: "large", children: (0, jsx_runtime_1.jsx)(products_1.ContactForm, { firstName: quote.contactDetails.firstName, lastName: quote.contactDetails.lastName, email: quote.contactDetails.email, useSendContactRequest: _service_1.unauthenticatedUserService.useSendContactRequest }) })] }));
};
exports.default = Contact;
